import React from 'react'
import styled from 'styled-components'
import { ReactComponent as RemoveIcon } from '../../../../../assets/remove.svg'

const Container = styled(RemoveIcon)`
  height: 20px;
  width: 20px;
  padding-right: 10px;
  fill: ${props => props.theme.colors.grey5};
  cursor: pointer;

  &:hover {
    fill: ${props => props.theme.colors.grey4};
  }
`

export default ({
  arrayHelpers: {
    remove,
  },
  index,
}) => (
  <Container onClick={() => remove(index)} />
)
